import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { BASE_URL } from "../../api/api";
import PaymentMISHook from "./PaymentMISHook";
import GlobalSearchhook from "../Review batches/GlobalSearchhook";
import { FaSearch } from "react-icons/fa";

const VendorMIS = () => {
  const [pendingData, setPendingData] = useState([]);
  const { VENDOR_LIST } = PaymentMISHook()
  const [selectedVendor, setSelectedVendor] = useState("");
  const [expandedBatch, setExpandedBatch] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { handleSearch, searchText, setSearchText } = GlobalSearchhook()

  useEffect(() => {
    const fetchPendingData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/GetPendingPaymentMISList`
        );
        const data = await response.json();

        if (data.status) {
          setPendingData(data.vendorList || []);

        } else {
          Swal.fire("Error", data.message || "Failed to fetch data", "error");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        Swal.fire("Error", "Something went wrong while fetching data", "error");
      }
    };

    fetchPendingData();
  }, []);

  const COLUMNS = [
    "Batch No",
    "Vendor Name",
    "Total Repair Charges",
    "Total Service Charges",
    "Final Payable Amount",
  ];

  const COLUMN_KEY_MAP = {
    "Batch No": "batchNo",
    "Vendor Name": "vendorName",
    "Total Repair Charges": "totalRepairCharges",
    "Total Service Charges": "totalServiceCharges",
    "Final Payable Amount": "finalPayableAmount",
  };

  const filteredData = pendingData.filter((item) => {
    if (
      selectedVendor &&
      item.vendorName?.toLowerCase() !== selectedVendor.toLowerCase()
    ) {
      return false;
    }
    if (fromDate || toDate) {
      const itemDate = new Date(item.records?.[0]?.created_Date);
      if (fromDate && itemDate < new Date(fromDate)) return false;
      if (toDate && itemDate > new Date(toDate)) return false;
    }
    return true;
  });

  const handleDownloadMIS = () => {
    if (filteredData.length === 0) return;

    const exportRows = [];

    filteredData.forEach((vendor) => {
      const mainRow = {};
      COLUMNS.forEach((col) => {
        mainRow[col] = vendor[COLUMN_KEY_MAP[col]] ?? "-";
      });
      exportRows.push(mainRow);

      vendor.records?.forEach((rec, i) => {
        exportRows.push({
          "SR No.": i + 1,
          "AA No": rec.aaNo ?? "-",
          "IMEI No": rec.imeiNo ?? "-",
          "Invoice No": rec.invoiceNo ?? "-",
          "Invoice Date": rec.created_Date?.split(" ")[0] ?? "-",
          "Repair Charges": rec.repairCharges ?? "-",
          "Service Charges": rec.serviceCharges ?? "-",
          "GST": rec.gst ?? "-",
          "TDS": rec.tds ?? "-",
          "Final Payable": rec.finalPayableAmount ?? "-",
          "Payment Status": rec.paymentStatus ?? "-",
          "GST Status": rec.gstStatus ?? "-",
        });
      });
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportRows);
    XLSX.utils.book_append_sheet(wb, ws, "Unpaid MIS");
    XLSX.writeFile(wb, "PendingPaymentMIS.xlsx");
  };

  return (
    <div className="container">
      <div className="pt-3 d-flex flex-wrap gap-3 align-items-end">
        <div style={{ minWidth: "250px" }}>
          <label className="mb-1 text-sm font-medium">Vendor Name</label>
          <select
            className="form-select"
            value={selectedVendor}
            onChange={(e) => setSelectedVendor(e.target.value)}
          >
            <option value="">All Vendors</option>
            {VENDOR_LIST.map((v, i) => (
              <option key={i} value={v}>
                {v}
              </option>
            ))}
          </select>
        </div>
        <div
          className="review_batch_seach input-group"
          style={{ maxWidth: "240px", marginRight: "10px" }}
        >
          <div className="fa_search_main">
            <span className="input-group-text bg-light fasearch">
              <FaSearch className="text-muted" />
            </span>
          </div>
          <input
            type="text"
            className="form-control bg-light border-start-0"
            placeholder="Global Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            style={{ borderLeft: "none", boxShadow: "none" }}
          />
        </div>
        <div>
          <label className="mb-1 text-sm font-medium">From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label className="mb-1 text-sm font-medium">To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div>
          <button
            className="btn btn-primary"
            style={{ backgroundColor: "#7E00D1", border: 0, width: 200 }}
            onClick={handleDownloadMIS}
          >
            <DownloadIcon /> Download MIS
          </button>
        </div>
      </div>

      {/* Main Table */}
      <div className="container mt-4" style={{ overflow: "auto" }}>
        {filteredData.length > 0 ? (
          <Table className="bg-white text-center border-0 network_table mt-3">
            <thead
              style={{
                backgroundColor: "#EEF4FF",
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >
              <tr className="text-dark fw-semibold table_th_border">
                <th>View</th>
                {COLUMNS.map((col) => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((vendor, idx) => {
                const isExpanded = expandedBatch === vendor.batchNo;
                return (
                  <React.Fragment key={idx}>
                    <tr className="text-center border-bottom network_td_item">
                      <td className="align-middle">
                        <button
                          className="btn btn-link p-0"
                          onClick={() =>
                            setExpandedBatch(isExpanded ? null : vendor.batchNo)
                          }
                          title="View Details"
                        >
                          <VisibilityIcon style={{ color: "#7E00D1" }} />
                        </button>
                      </td>

                      {COLUMNS.map((col) => (
                        <td key={col}>
                          {vendor[COLUMN_KEY_MAP[col]] !== null &&
                            vendor[COLUMN_KEY_MAP[col]] !== ""
                            ? vendor[COLUMN_KEY_MAP[col]]
                            : "-"}
                        </td>
                      ))}
                    </tr>

                    {/* Expanded Row */}
                    {isExpanded && (
                      <tr>
                        <td colSpan={COLUMNS.length + 1}>
                          <div className="p-2">
                            <Table bordered size="sm">
                              <thead style={{ background: "#f7f7f7" }}>
                                <tr>
                                  <th>SR No.</th>
                                  <th>AA No</th>
                                  <th>IMEI No</th>
                                  <th>Invoice No</th>
                                  <th>Invoice Date</th>
                                  <th>Repair Charges</th>
                                  <th>Service Charges</th>
                                  <th>GST</th>
                                  <th>TDS</th>
                                  <th>Final Payable</th>
                                  <th>Payment Status</th>
                                  <th>GST Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {vendor.records?.map((rec, i) => (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{rec.aaNo}</td>
                                    <td>{rec.imeiNo}</td>
                                    <td>{rec.invoiceNo}</td>
                                    <td>{rec.created_Date?.split(" ")[0]}</td>
                                    <td>{rec.repairCharges}</td>
                                    <td>{rec.serviceCharges}</td>
                                    <td>{rec.gst}</td>
                                    <td>{rec.tds}</td>
                                    <td>{rec.finalPayableAmount}</td>
                                    <td>{rec.paymentStatus || "-"}</td>
                                    <td>{rec.gstStatus || "-"}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <p className="mt-4 text-center text-muted">No data found</p>
        )}
      </div>
    </div>
  );
};

export default VendorMIS;
